import React from "react";
import { useLocation } from "react-router-dom";
import About from "../pages/About/About";
import Default from "../pages/Default/Default";
import Enterprise from "../pages/Enterprise/Enterprise";
import ProductV2 from "../pages/Product/Product_v2";
import Terms from "../pages/Terms/Terms";
import Privacy from "../pages/Privacy/Privacy";
import Cookies from "../pages/Cookies/Cookies";
import VMSServices from "../pages/VMSServices/VMSServices";
import WeatherFactor from "../pages/WeatherFactor/WeatherFactor";
import WeatherInPort from "../pages/WeatherInPort/WeatherInPort";
import BunkerRoute from "../pages/BunkerRoute/BunkerRoute";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Main: React.FC = () => {
  const query = useQuery();
  const page = query.get("page");

  return (
    <>
      {page === "about" && <About />}
      {page === "terms" && <Terms />}
      {page === "privacy" && <Privacy />}
      {page === "cookies" && <Cookies />}
      {page === "product" && <ProductV2 />}
      {/* product-old unrouted 2026-09-12 (D-PUB7): Product.tsx stays in the repo, its
          "single user subscriptions" copy contradicts the enterprise-only contract model. */}
      {page === "vmsservices" && <VMSServices />}
      {page === "enterprise" && <Enterprise />}
      {/* Old pricing links keep working — the page is now the Enterprise page. */}
      {page === "price" && <Enterprise />}
      {page === "wf" && <WeatherFactor />}
      {page === "weatherinport" && <WeatherInPort />}
      {page === "bunker" && <BunkerRoute />}
      {!page && <Default />}
    </>
  );
};

export default Main;